import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';

import Slider from '../../../../components/Slider';
import theme from '../../../../styled-components/dark';

const Wrapper = styled.div`
  width: 100%;
  padding: 0 0.75em;
  margin-top: -0.25em;
  margin-bottom: 1em;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledSlider = styled(Slider)`
  padding: 0 1em 0 2em;
  width: 100%;
  flex: 3;
`;

const SliderValue = styled.div`
  color: ${theme.Slider.default.tooltipColor};
  background-color: ${theme.LineUpSlider.infoBackgroundColor};
  flex: 1;
  height: 1.8em;
  line-height: normal;
  font-weight: bold;
  border-radius: 9999px;
  text-align: center;
  padding: 0.2em 0.4em;
`;

type LineUpSliderProps = {
  values: Array<{ value: string; label: string }>;
  currentValue?: string;
  onValueChange: (value: string) => void;
};

const LineUpSlider = ({ values, currentValue, onValueChange }: LineUpSliderProps) => {
  const index = useMemo(() => {
    const allValues = values.map((value) => value.value);
    if (currentValue) {
      return allValues.indexOf(currentValue) !== -1 ? allValues.indexOf(currentValue) : 0;
    }
    return 0;
  }, [values, currentValue]);

  const onChange = useCallback((index: number) => onValueChange(values[index].value), [values, onValueChange]);

  const label = useMemo(() => values.find((value) => value.value === currentValue)?.label, [values, currentValue]);

  return (
    <Wrapper>
      <SliderValue>{label}</SliderValue>
      <StyledSlider
        step={1}
        min={0}
        max={values.length > 0 ? values.length - 1 : 0}
        value={index}
        onChange={onChange}
        hideAnchors
        hideTooltip
      />
    </Wrapper>
  );
};

export default LineUpSlider;
